import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	padding: 100px 20px;
	max-width: 1240px;
	margin: 0 auto;

	h3 {
		text-align: center;
		font-size: ${CSSVars.fontSize2XL};
		max-width: 800px;
		margin: 0 auto 20px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}
	}

	p.description {
		font-size: ${CSSVars.fontSizeMD};
		text-align: center;
		max-width: 600px;
		margin: 0 auto;
	}

	.bento-container {
		margin-top: 80px;
		gap: 50px;
		display: grid;
		grid-template-areas:
			'item-1'
			'item-2'
			'item-3'
			'item-4'
			'item-5'
			'item-6'
			'item-7'
			'item-8';

		&.in-view {
			.bento-item {
				animation: fadeInUp 0.5s ease-out forwards;
			}
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-areas:
				'item-2 item-2'
				'item-1 item-3'
				'item-1 item-4'
				'item-5 item-5'
				'item-6 item-6'
				'item-7 item-7'
				'item-8 item-8';
		}

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			grid-template-areas:
				'item-1 item-2 item-2'
				'item-1 item-3 item-4'
				'item-5 item-5 item-6'
				'item-7 item-8 item-8';
		}

		.bento-item {
			--padding: 25px;
			border-radius: 10px;
			position: relative;
			border: 2px solid #1c1c20;
			padding: var(--padding);
			overflow: hidden;
			background: rgb(24, 24, 28);
			background: linear-gradient(
				-175deg,
				rgba(24, 24, 28, 1) 0%,
				rgba(0, 0, 0, 1) 100%
			);
			transition: 0.3s;
			opacity: 0;

			.bento-content {
				z-index: 2;
				position: relative;

				h4 {
					font-size: ${CSSVars.fontSizeXL};
					font-weight: 600;
					margin-bottom: 10px;
					text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.9);
				}

				p {
					font-size: ${CSSVars.fontSizeMD};
					font-weight: 300;
				}
			}

			.bento-image-container {
				z-index: 1;

				img {
					max-width: 100%;
					pointer-events: none;
					top: auto !important;
					bottom: auto !important;
					left: auto !important;
					right: auto !important;
				}
			}

			&.item-1 {
				grid-area: item-1;
				padding-bottom: 600px;
				position: relative;

				&::after {
					content: '';
					z-index: -1;
					position: absolute;
					background: rgb(255, 151, 156);
					background: linear-gradient(
						0deg,
						rgba(255, 151, 156, 0.6) 0%,
						rgba(255, 151, 156, 0) 30%
					);
					bottom: 0;
					left: 0;
					right: 0;
					height: 600px;
				}

				img {
					left: 50% !important;
					transform: translateX(-50%);
					width: 365px !important;
					height: 450px !important;
					bottom: -5px !important;
				}
			}

			&.item-2 {
				grid-area: item-2;
				padding-top: 200px;
				padding-right: 100px;

				.bento-content {
					max-width: 325px;
				}

				img {
					top: 0 !important;
					right: 0 !important;
					width: 600px !important;
					height: 365px !important;
				}
			}

			&.item-3 {
				grid-area: item-3;
				display: flex;
				flex-direction: column;

				.bento-image-container {
					width: 365px;
					height: 200px;

					img {
						top: 0 !important;
						left: 50% !important;
						transform: translateX(-50%);
						width: 365px !important;
						height: 200px !important;
					}
				}
			}

			&.item-4 {
				grid-area: item-4;
				display: flex;
				flex-direction: column;

				.bento-image-container {
					width: 365px;
					height: 200px;
					order: 2;

					img {
						bottom: 0 !important;
						left: 50% !important;
						transform: translateX(-50%);
						width: 365px !important;
						height: 200px !important;
					}
				}
			}

			&.item-5 {
				grid-area: item-5;
				padding-top: 220px;
				padding-right: 100px;

				&::after {
					content: '';
					z-index: -1;
					position: absolute;
					background: rgb(76, 79, 225);
					background: linear-gradient(
						-90deg,
						rgba(76, 79, 225, 0.6) 0%,
						rgba(76, 79, 225, 0) 30%
					);

					bottom: 0;
					top: 0;
					right: 0;
					width: 900px;
				}

				.bento-content {
					max-width: 325px;
				}

				img {
					top: 0 !important;
					right: 0 !important;
					width: 600px !important;
					height: 365px !important;
				}
			}

			&.item-6 {
				grid-area: item-6;
				display: flex;
				flex-direction: column;
				gap: 20px;

				.bento-image-container {
					width: 365px;
					height: 200px;
					order: 2;
					margin: 0 auto;

					img {
						bottom: 0 !important;
						left: 50% !important;
						transform: translateX(-50%);
						width: 365px !important;
						height: 200px !important;
					}
				}
			}

			&.item-7 {
				grid-area: item-7;
				display: flex;
				flex-direction: column;

				.bento-image-container {
					width: 365px;
					height: 200px;
					order: 2;

					img {
						bottom: 0 !important;
						right: 0 !important;
						width: 365px !important;
						height: 200px !important;
					}
				}
			}

			&.item-8 {
				grid-area: item-8;
				position: relative;

				&::after {
					content: '';
					z-index: -1;
					position: absolute;
					background: rgb(255, 151, 156);
					background: linear-gradient(
						0deg,
						rgba(255, 151, 156, 0.6) 0%,
						rgba(255, 151, 156, 0) 30%
					);
					bottom: 0;
					left: 0;
					right: 0;
					height: 600px;
				}
				padding-top: 200px;
				padding-right: 100px;

				.bento-content {
					max-width: 325px;
				}

				img {
					top: 0 !important;
					right: 0 !important;
					width: 600px !important;
					height: 365px !important;
				}
			}
		}
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(50px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;
